// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"90":"001f4256","287":"6d968a55","841":"71eccac2"}[chunkId] + ".js";
};